import React from 'react';

const MENU_CONTAINER = ({link, icon, is_home}) => {
  return (
      <li className={is_home ? "active" : ''} >
        <a href={link}>
          <span className='icon'> {icon} </span>
        </a>
      </li>
  )
};

export default MENU_CONTAINER;
